import React from 'react'

export default function AdditionalProfileCreatedModal({profile,complete}) {

 //styled

    const handleClick = () => {
        complete();
    }

    return (
        <div className="send-modal-overlay">
  
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Additional Profile Created</p></div> 
        <p>An additional profile has been created successfully.</p>

            <div className="send-modal-footer">
              <button  className="pointer cancelButton fw-bold mx-2 px-3"onClick={handleClick}>Okay</button>
           
            </div>
        
        </div>
      </div>
      )
    }